import { types } from "../types/types";
import { auth } from "../../firebase-config";
import {
    signInWithEmailAndPassword,
    signOut,
    createUserWithEmailAndPassword,
    updateProfile,
    signInWithPopup
} from "firebase/auth";
import { finishLoading, startLoading } from "./graphicalActions";
import { useAlert } from "../../hooks/useAlert";

export const setLogin = (data) => ({
    type: types.login,
    payload: data
});

export const setLogout = () => ({
    type: types.logout,
    payload: null
});

export const logout = () => ({
    type: types.logout
})



export const makeLoginFirebase = ({
    loginEmail,
    loginPassword
}) => {

    return async (dispatch) => {

        dispatch(startLoading());

        try {
            const user: any = await signInWithEmailAndPassword(
                auth,
                loginEmail,
                loginPassword
            );

            dispatch(
                setLogin(user?.user)
            );
        } catch (error) {
            useAlert('Error!', '').fire(<div> {error.message} </div>);
        } finally {
            dispatch(finishLoading());
        }
    }
}


export const makeRegisterFirebase = ({ registerEmail,
    registerPassword, registerName }) => {
    return async (dispatch) => {
        dispatch(startLoading());

        try {
            const result = await createUserWithEmailAndPassword(
                auth,
                registerEmail,
                registerPassword
            );

            await updateProfile(auth.currentUser, {
                displayName: registerName
            })

            dispatch(setLogin(result?.user));

        } catch (error) {
            useAlert('Error!', '').fire(<div> {error.message} </div>);
        } finally {
            dispatch(finishLoading());
        }
    }
}

export const makeLoginExternal = (provider) => {
    return async (dispatch) => {

        dispatch(startLoading());

        try {
            const result = await signInWithPopup(auth, provider);
            if (result?.user?.uid) {
                dispatch(setLogin(result?.user));
            }
        } catch (error) {
            useAlert('Error!', '').fire(<div> {error.message} </div>);
        } finally {
            dispatch(finishLoading());
        }
    }
}

export const makeLogout = () => {
    return async (dispatch) => {
        try {
            await signOut(auth);
            dispatch(logout());
        } catch (error) {
            useAlert('Error!', '').fire(<div> {error.message} </div>);
        }
    }
}